import { IEditCommand } from "./IEditCommand";
import { AbstractEditEntityCommand } from "./AbstractEditEntityCommand";

export class EditEntityCommand<TSource, TEntity> extends AbstractEditEntityCommand<TSource, TEntity> {
  constructor(private readonly _toEntity: (s: TSource) => TEntity, command: IEditCommand<TEntity>) {
    super(command);
  }

  protected toEntity(source: TSource): TEntity {
    return this._toEntity(source);
  }
}
